import { Spin } from "antd";

const ClickImpressionBox = ({
  loading,
  data,
  title,
  lang,
  currentLanguage,
}) => {
  return (
    <div className="click-imp-box">
      {loading ? (
        <div className="w-100 h-100 d-flex justify-content-center align-items-center">
          <Spin size="large" />
        </div>
      ) : (
        <>
          <p className=" text-14 text-2E2E30 font-500 mb-20">{title}</p>

          <div className="d-flex justify-content-between px-10">
            <div className="d-flex">
              <p
                className={`text-18 font-600 ${
                  lang === "ar" ? "ml-10" : "mr-10"
                } mb-0`}
              >
                {data?.count}
              </p>
              <img
                width={10}
                height={25}
                src={
                  data?.trend === "up"
                    ? "/dashboard/up.svg"
                    : data?.trend === "down"
                    ? "/dashboard/down.svg"
                    : "/dashboard/same.svg"
                }
                alt="trend"
              />
            </div>
            <div>
              <img
                src={
                  data?.trend === "up"
                    ? "/dashboard/graphgreen.svg"
                    : data?.trend === "down"
                    ? "/dashboard/graphred.svg"
                    : "/dashboard/graphsame.svg"
                }
                alt="graph"
              />
            </div>
            <div>
              <p className="text-14 text-2E2E30 mb-0 font-700">{title}</p>
              <p className="text-12 text-2E2E30 mb-0 font-500">
                <span
                  className={
                    data?.trend === "up"
                      ? "text-5DB48A"
                      : data?.trend === "down"
                      ? "text-F97066 "
                      : "text-F8B02B"
                  }
                >
                  {/* {data?.trend === 'up' || data?.trend === 'same' ? '+' : '-'} */}
                  {data?.percentage}%{" "}
                </span>
                {currentLanguage?.since_last_month}
              </p>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default ClickImpressionBox;
